import type * as api from '@gitbook/api-client';
import { checkIsPaidSiteProductKey, checkIsUnrestrictedProductKey } from '@gitbook/app-pricing';

/**
 * Determines whether the publish dialog should be skipped for a given site and organization.
 *
 * Skip publish dialog if:
 *  - the organization is trialing, enterprise, community or internal
 *  - the site is not paid (legacy sites, basic or sponsored)
 */
export function shouldSkipPublishDialog(
    site: api.Site,
    organization: api.Organization,
    isTrialingOrg: boolean
): boolean {
    const isUnrestrictedOrg = checkIsUnrestrictedProductKey(organization.plan);
    const isPaidSite = checkIsPaidSiteProductKey(site.type);

    return isTrialingOrg || isUnrestrictedOrg || !isPaidSite;
}
